module.exports = __webpack_public_path__ + "static/exterior-3-db4d7abb4eeb59bf3102798f5f2302af.jpg";